/* eslint-disable array-callback-return */
import ComposeEmailComponent from './compose';
import CustomInput from '../reusable/input';
import { EmailObject } from '../../params/redux/email';
import { fetchThreadMessagesThunk } from '../../redux/thunks/email';
import { formatDateWithTime } from '../../helper';
import SelectedEmailComponent from './selected_email';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, IconButton, InputAdornment, Typography } from '@mui/material';
import { DraftsOutlined, MailOutline, RepeatRounded, Search } from '@mui/icons-material';
import { settingComposingFlagEmail, settingIsInboxFlagEmail, settingSelectedEmail } from '../../redux/slices/email';
import { useDispatch, useSelector } from 'react-redux';

const EmailDetailComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [search, setSearch] = useState<string>('');
    const { integrations } = useSelector((state: RootState) => state.integration);
    const { flags, emails, selectedEmail, loaders } = useSelector((state: RootState) => state.email);

    const filteredMails = emails.filter((e: EmailObject) => {
        const subject = e.subject.toLowerCase();
        const body = e.body.toLowerCase();
        const to = e.to_email.toLowerCase();
        return (
            !search ||
            subject.includes(search.toLowerCase()) ||
            body.includes(search.toLowerCase()) ||
            to.includes(search.toLowerCase())
        );
    });

    const filteredInboxMails = filteredMails.filter((e: EmailObject) => {
        const isSent = e.is_sent === 1;
        return flags.isInbox ? !isSent : isSent;
    });

    const changeInboxHandler = (value: boolean) => {
        dispatch(settingIsInboxFlagEmail(value));
    };

    const composeHandler = () => {
        dispatch(settingComposingFlagEmail(true));
    };

    const doesIntegratedOrNot = integrations.includes('email') || flags.isIntegrated;

    const selctedEmailHandler = async (email: EmailObject) => {
        try {
            dispatch(settingSelectedEmail(email));
            await dispatch(fetchThreadMessagesThunk({ thread_id: email.id, client_id: id ? parseInt(id as string, 10) : 0 })).unwrap();
        } catch (e) {
            //
        }
    };


    if (flags.composing && doesIntegratedOrNot) {
        return <ComposeEmailComponent />;
    } else if (selectedEmail && doesIntegratedOrNot) {
        return <SelectedEmailComponent />;
    }

    return (<Box minHeight="60vh">
        <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
            <Box display="flex" width="100%" gap={2}>
                <Box display="flex"><Button variant={flags.isInbox ? 'contained' : 'outlined'} color="primary" disabled={loaders.isLoading} onClick={() => changeInboxHandler(true)} sx={{
                    borderTopRightRadius: '0',
                    borderBottomRightRadius: '0'
                }}>Inbox</Button>
                    <Button variant={flags.isInbox ? 'outlined' : 'contained'} color="primary" disabled={loaders.isLoading} onClick={() => changeInboxHandler(false)} sx={{
                        borderTopLeftRadius: '0',
                        borderBottomLeftRadius: '0'
                    }}>Sent</Button></Box>
                <Box width="100%"><CustomInput
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    slotProps={{
                        input: {
                            startAdornment: <InputAdornment position="start">
                                <Search />
                            </InputAdornment>
                        }
                    }} disabled={loaders.isLoading}
                    placeholder="Search..."
                /></Box>
            </Box>
            <Box width="100%"><Typography variant="h3" color="textSecondary" fontWeight="bold">{flags.isInbox ? 'Inbox Mails' : 'Sent Mails'}</Typography></Box>
            <Box display="flex" gap={2}>
                <IconButton color="primary" sx={{ display: 'none' }} onClick={() => null} disabled={loaders.isLoading}>
                    <RepeatRounded />
                </IconButton>
                <Button variant="text" sx={{ display: 'none' }} startIcon={<DraftsOutlined />} disabled={loaders.isLoading} >Mark all as read</Button>
                <Button variant="contained" startIcon={<MailOutline />} disabled={loaders.isLoading} onClick={composeHandler}>Compose</Button>
            </Box>
        </Box>

        <Box display="flex" flexDirection="column" gap={1} my={2}>
            {
                filteredInboxMails.map((email) => <Box key={email.id} display="flex" justifyContent="space-between" alignItems="center" border="1px solid #ddd" sx={{
                    cursor: 'pointer'
                }} borderRadius={1} p={2} onClick={() => selctedEmailHandler(email)}>
                    <Typography variant="body1" color="textSecondary" fontWeight="bold">{email.to_email}
                        <Typography component="span" variant="body1" color="textDisabled" mx={1}> ({email.thread_count})</Typography>
                        <Typography component="span" fontWeight="500" color="textDisabled">{email.subject}</Typography></Typography>
                    <Typography variant="body2" color="textDisabled">{formatDateWithTime(email.created_at)}</Typography>
                </Box>)
            }
        </Box>
    </Box>);
};

export default EmailDetailComponent;